<template>
  <div>
    <card class="w=100">
      <el-form>
        <el-row>
          <el-col :span="18">
            <map-component ref="map" :width="610" :read-only="false" :store-seq="storeFloor.storeSeq"
                           :store-floor-seq="storeFloor.storeFloorSeq" v-on:mousedown="mousedown"></map-component>
            <el-row style="margin-top: 5px">
              <el-col :span="24">
                <div style="margin-bottom: 1px">
                  <el-row :gutter="10" v-if="mediaInfo.show">
                    <el-col :span="24">
                      방향 :
                      <el-button type="primary" style="margin-left: 5px;" :disabled="mediaInfo.direction === 'top'" @click="changeDirection('top')">위쪽</el-button>
                      <el-button type="primary" style="margin-left: 5px;" :disabled="mediaInfo.direction === 'right'" @click="changeDirection('right')">오른쪽</el-button>
                      <el-button type="primary" style="margin-left: 5px;" :disabled="mediaInfo.direction === 'bottom'" @click="changeDirection('bottom')">아래쪽</el-button>
                      <el-button type="primary" style="margin-left: 5px;" :disabled="mediaInfo.direction === 'left'" @click="changeDirection('left')">왼쪽</el-button>
                    </el-col>
                    <el-col :span="24" style="margin-top: 10px">
                      위치 : <el-input v-model="mediaInfo.position"
                                minlength="1"
                                width="200"
                                show-word-limit
                                style="width: 200px; margin-left: 5px"
                                @change="changePosition"></el-input>
                    </el-col>
                    <el-col :span="24" style="margin-top: 10px">
                      폰트색 :
                      <el-button type="primary" style="margin-left: 5px;" :disabled="mediaInfo.fontColor === 'white'" @click="changeFontColor('white')">흰색</el-button>
                      <el-button type="primary" style="margin-left: 5px;" :disabled="mediaInfo.fontColor === 'black'" @click="changeFontColor('black')">검정색</el-button>
                    </el-col>
                    <el-col :span="24" style="margin-top: 10px">
                      <el-button type="primary" style="margin-left: 5px;" @click="saveMediaInfo()">수정</el-button>
                      <el-button type="primary" style="margin-left: 5px;" @click="deleteMediaInfo()">삭제</el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <el-table class="table-striped"
                      border
                      style="width: 100%; margin-bottom: 10px; font-size: 12px"
                      :data="$store.state.media.mediaInfos"
                      :header-cell-style="tableRowStyle"
                      height="600">
              <el-table-column
                label="색상"
                width="75"
                align="center">
                <template slot-scope="props">
                  <el-button :style="'background-color:' +  props.row.color" circle></el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="mediaName"
                label="매체명">
              </el-table-column>
              <el-table-column
                label="추가">
                <template slot-scope="props">
                  <el-button  size="mini" icon="el-icon-plus"
                             @click="addMediaInfo(props.$index, props.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="card-footer">
          <el-row>
            <el-col :span="24" class="text-right" style="margin-bottom: 1px">
              <el-button type="primary" @click="saveElements()">저장</el-button>
              <el-button @click.prevent="historyBack">취소</el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </card>
    <card class="w=100">
      <el-row>
        <el-col :span="8">
          <el-select v-model="storeFloor.floorType">
            <el-option
              key="F"
              value="F"
              label="지상"></el-option>
            <el-option
              key="B"
              value="B"
              label="지하"></el-option>
          </el-select>
          <el-select v-model="storeFloor.floor">
            <el-option v-for="f in 10"
                       :key="f"
                       :value="f"
                       :label="f"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">

          <el-upload
            class="upload-demo"
            ref="upload"
            :action="'/api/store/store-floors/' + this.$route.params.storeFloorSeq"
            :headers="header"
            :data="getFormParam"
            :limit="1"
            :on-success="handleSuccess"
            :auto-upload="false">
            <el-button slot="trigger" type="primary">도면 변경</el-button>&nbsp;
            <el-button type="primary" icon="el-icon-check" @click="submitUpload">저장</el-button>
          </el-upload>

        </el-col>
        <el-col :span="12" class="text-right">
        </el-col>
      </el-row>
    </card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Select, Form, FormItem, Button, Option, Input, Row, Col, Upload, Table, TableColumn} from 'element-ui';
  import StoreProxy from "../../../../proxies/StoreProxy";
  import StoreFloorProxy from "../../../../proxies/StoreFloorProxy";
  import MapComponent from "../Common/MapComponent";

  Vue.use(Form);
  Vue.use(FormItem);
  Vue.use(Col);
  Vue.use(Row);
  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(Button);
  Vue.use(Upload)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Input)

  export default {
    name: "StoreFloorEdit",
    components: {
      MapComponent
    },
    created: function () {
      this.$store.dispatch('common/setMenuTitle', "도면수정");
      this.storeFloor.storeSeq = this.$route.params.storeSeq;
      this.storeFloor.storeFloorSeq = this.$route.params.storeFloorSeq;
      this.findStoreFloorById(this.storeFloor.storeSeq, this.storeFloor.storeFloorSeq);

      this.$store.dispatch('media/findAll', {
        searchName: null,
        searchMediaType: null
      });
    },
    computed: {
      getFormParam: function () {
        return this.storeFloor;
      },
    },
    methods: {
      findStoreFloorById(storeSeq, storeFloorSeq) {
        new StoreProxy()
          .findStoreFloorById(storeSeq, storeFloorSeq)
          .then((response) => {
            this.storeFloor = response.storeFloor;
          });
      },
      tableRowStyle() {
        return this.$store.state.common.tableHeaderFont10CellStyle;
      },
      historyBack() {
        history.back();
      },
      handleSuccess(response, files, fileList) {
        this.$refs.map.reloadMap(files.size);
        this.$refs.upload.clearFiles();
        alert("저장되었습니다.");
      },
      submitUpload() {
        if (this.$refs.upload.uploadFiles.length > 0) {
          this.$refs.upload.submit();
        } else {
          alert("도면을 선택하세요.");
        }
      },
      addMediaInfo(index, row) {
        this.$refs.map.addMediaInfo(row);
      },
      mousedown(tElement) {
        this.mediaInfo.id = tElement.id;
        this.mediaInfo.show = true;
        this.mediaInfo.direction = this.getDirection(tElement.class);
        this.mediaInfo.fontColor = this.getColor(tElement.class);
        this.mediaInfo.position = tElement.text;
      },
      saveMediaInfo() {
        this.mediaInfo.id = "";
        this.mediaInfo.show = false;
      },
      deleteMediaInfo() {
        this.$refs.map.deleteElementById(this.mediaInfo.id);
        this.saveMediaInfo();
      },
      getColor(c) {
        let color = "white";
        if(c.indexOf("white") >= 0) {
          color = "white";
        } else if(c.indexOf("black") >= 0) {
          color = "black";
        }

        return color;
      },
      getDirection(c) {
        let direction = "top";
        if (c.indexOf("top") >= 0) {
          direction = "top";
        } else if (c.indexOf("left") >= 0) {
          direction = "left";
        } else if (c.indexOf("bottom") >= 0) {
          direction = "bottom";
        } else if (c.indexOf("right") >= 0) {
          direction = "right";
        }
        return direction;
      },
      changeDirection(value) {
        this.mediaInfo.direction = value;
        this.$refs.map.changeDirection(value, this.mediaInfo.id);
      },
      changeFontColor(value) {
        this.mediaInfo.fontColor = value;
        this.$refs.map.changeFontColor(value, this.mediaInfo.id);
      },
      changePosition(value) {
        this.$refs.map.changePosition(value, this.mediaInfo.id);
      },
      saveElements() {
        this.elements = this.$refs.map.getElements();
        if (this.elements.length > 0) {
          this.elements.forEach(element => {
            element.positionId = element.id;
            element.positionText = element.text;
            element.className = element.class;
            element.storeFloorSeq = this.storeFloor.storeFloorSeq;
          });
          new StoreFloorProxy()
            .createMediaPosition(this.storeFloor.storeFloorSeq, this.elements)
            .then((response) => {
              if (response.header.returnCode === "OK") {
                alert("완료되었습니다.")
              } else {
                alert(response.header.resultMessages);
              }
            })
        } else {
          alert("등록된 매체가 없습니다.");
        }
      },
    },
    data() {
      return {
        mediaInfo: {
          id: '',
          direction: 'top',
          position: '',
          show: false,
          fontColor: 'white',
        },
        storeFloor: {
          storeSeq: null,
          storeFloorSeq: null,
          floor: 1,
          floorType: "F",
        },
        header: {
          Authorization: $cookies.get('id_token')
        },
        formData: {
          floorType: "F",
          floor: 1,
        },
        elements: [],
      }
    },
  }
</script>

<style scoped>
</style>
